import { render, staticRenderFns } from "./GradingPlanAdd.vue?vue&type=template&id=4062f6a7&"
import script from "./GradingPlanAdd.vue?vue&type=script&lang=js&"
export * from "./GradingPlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports